import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
const BASE_TEST_URL = "https://bf6q09zw9f.execute-api.ap-southeast-1.amazonaws.com/test/api/"
// const BASE_TEST_URL = "https://simply.api.prod.proxyedge.io/general/api/"
const BASE_PROD_URL = "https://simply.api.prod.proxyedge.io/general/api/"

export const BASE_URL = (
  (process.env.NODE_ENV === "production"
   || process.env.VERCEL_ENV === "production")
  ? BASE_PROD_URL
  : BASE_TEST_URL);

/**
 * Empty API for code generation with @rtk-query/codegen-openapi
 */
export const emptyV2Api = createApi({
  reducerPath: "simplyV2Api",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    timeout: 900000
  }),
  endpoints: () => ({})
});
